import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { Feather } from "@expo/vector-icons";
import { spacing } from "../../theme";
import { useColors, ThemeColors } from "../../hooks/useColors";

export function SavedAddressList({
  addresses,
  onSelect,
  onDelete,
  selectedId,
}) {
  const colors = useColors();
  const styles = createStyles(colors);
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Saved Addresses</Text>
      {addresses.map((address) => (
        <TouchableOpacity
          key={address.id}
          style={[
            styles.addressItem,
            address.id === selectedId && styles.selectedAddress,
          ]}
          onPress={() => onSelect(address)}
        >
          <View style={styles.addressInfo}>
            <Text style={styles.addressText}>
              {address.street_address}
              {address.apartment ? ` #${address.apartment}` : ""}
            </Text>
            <Text style={styles.addressDetails}>
              {address.city}, {address.state} {address.zip_code}
            </Text>
            {address.delivery_instructions && (
              <Text style={styles.deliveryInstructions}>
                📋 {address.delivery_instructions}
              </Text>
            )}
          </View>
          {address.is_default ? (
            <View style={styles.defaultBadge}>
              <Text style={styles.defaultText}>Default</Text>
            </View>
          ) : (
            <TouchableOpacity
              style={styles.deleteButton}
              onPress={(e) => {
                e.stopPropagation();
                onDelete(address);
              }}
            >
              <Feather name="trash-2" size={20} color={colors.error} />
            </TouchableOpacity>
          )}
        </TouchableOpacity>
      ))}
    </View>
  );
}

const createStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      marginBottom: spacing.lg,
    },
    title: {
      fontSize: 16,
      fontWeight: "600",
      marginBottom: spacing.sm,
      color: colors.text,
    },
    addressItem: {
      flexDirection: "row",
      padding: spacing.md,
      backgroundColor: colors.background,
      borderRadius: 8,
      marginBottom: spacing.sm,
      borderWidth: 1,
      borderColor: colors.border,
      alignItems: "center",
    },
    selectedAddress: {
      borderColor: colors.primary,
      backgroundColor: colors.backgroundSecondary,
    },
    addressInfo: {
      flex: 1,
    },
    addressText: {
      fontSize: 16,
      marginBottom: 2,
      color: colors.text,
    },
    addressDetails: {
      fontSize: 14,
      color: colors.textLight,
    },
    deliveryInstructions: {
      fontSize: 12,
      color: colors.textSecondary,
      fontStyle: "italic",
      marginTop: 2,
    },
    defaultBadge: {
      backgroundColor: colors.primary,
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: 4,
    },
    defaultText: {
      color: colors.surface,
      fontSize: 12,
    },
    deleteButton: {
      padding: spacing.md,
      paddingLeft: spacing.lg,
    },
  });
